import { render, staticRenderFns } from "./Answersheet.vue?vue&type=template&id=4c5466fe&scoped=true&"
import script from "./Answersheet.vue?vue&type=script&lang=js&"
export * from "./Answersheet.vue?vue&type=script&lang=js&"
import style0 from "./Answersheet.vue?vue&type=style&index=0&id=4c5466fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5466fe",
  null
  
)

export default component.exports